import React from 'react'
// libs
import styled from 'styled-components'
// icons
import CloseIconOrigin from '@mui/icons-material/CloseRounded'
// themes
import { colors } from 'themes/index'
// utils
import { darken, size } from 'polished'

// types
interface ComponentProps {
  iconSize?: number
  marginLeft?: number
}

const AddButton = styled('div')`
  && {
    color: ${colors.blue500};
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    margin: 12px auto 0 0;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`

const ConditionWrapper = styled('div')<ComponentProps>`
  margin-bottom: 8px;
  margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : 0)};
  pointer-events: none;
  width: 72px;

  * {
    font-size: 14px;
    font-weight: 500;
    color: ${colors.purple300} !important;
    text-overflow: unset !important;
  }

  svg {
    display: none;
  }

  > div > div > div > div > div :before {
    display: none;
  }
`

const CloseIcon = styled(({ iconSize, marginLeft, ...props }) => <CloseIconOrigin {...props} />)<ComponentProps>`
  && {
    cursor: pointer;
    margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : 'auto')};
    ${({ iconSize }) => size(`${iconSize ? iconSize : 20}px`)};
  }
`

const InputWrapper = styled('div')`
  display: flex;
  align-items: baseline;

  > div {
    margin-right: 8px;
  }
`

export { AddButton, ConditionWrapper, CloseIcon, InputWrapper }
